import { Col, Row } from "react-bootstrap";
import React from "react";
import ExpressionsContainer from "../redux/containers/ExpressionsContainer";
import DiagramModelContainer from "../redux/containers/DiagramModelContainer";
import styles from "./DiagramSystem.module.css";
export class DiagramSystem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      className: styles.reactDiagram
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement(DiagramModelContainer, {
      store: this.props.store
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement(ExpressionsContainer, {
      diagramModel: this.props.diagramModel
    }))));
  }

}